import {
  EmployeeAvailableForPlanningResponse,
  EmployeeAvailableForPlanningResponseItem
} from '@/types/service-response'

export class EmployeeAvailableForPlanning {
  private constructor (
    readonly id: number,
    readonly name: string,
    readonly capacity: string,
    readonly isFloater: boolean,
    readonly competenceName: string,
    readonly planingGroupName: string,
    readonly isAlreadySelected: boolean
  ) {}

  public static createListFromResponse (data: EmployeeAvailableForPlanningResponse): EmployeeAvailableForPlanning[] {
    return data.map((item: EmployeeAvailableForPlanningResponseItem): EmployeeAvailableForPlanning => {
      return new EmployeeAvailableForPlanning(
        item.MitarbeiterID,
        item.Name,
        item.Kapazitat,
        item.springer,
        item.Kompetenz,
        item.Planungsgruppe,
        item.AlreadySelect
      )
    })
  }

  public updateCapacity (capacity: string): EmployeeAvailableForPlanning {
      return new EmployeeAvailableForPlanning(
        this.id,
        this.name,
        capacity,
        this.isFloater,
        this.competenceName,
        this.planingGroupName,
        this.isAlreadySelected
      )
    }
}
